/**
 * @file FullScreen.js
 */
import {bind} from 'lodash';

const config = {};
if (document.cancelFullscreen) {
    config.requestFullscreen = document.body.requestFullscreen;
    config.cancelFullscreen = document.cancelFullscreen;
    config.fullscreenElement = 'fullscreenElement';
    config.fullscreenEvent = 'fullscreenchange';
}
else if (document.webkitCancelFullScreen) {
    config.requestFullscreen = document.body.webkitRequestFullScreen;
    config.cancelFullscreen = document.webkitCancelFullScreen;
    // 。。为啥webkit下其他都是大写的S，这边成小写的s了
    config.fullscreenElement = 'webkitFullscreenElement';
    config.fullscreenEvent = 'webkitfullscreenchange';
}
else if (document.mozCancelFullScreen) {
    config.requestFullscreen = document.body.mozRequestFullScreen;
    config.cancelFullscreen = document.mozCancelFullScreen;
    config.fullscreenElement = 'mozFullScreenElement';
    config.fullscreenEvent = 'mozfullscreenchange';
}

export default class FullScreen {
    constructor({openCallback, cancelCallback}) {
        this.onFullscreenChangedBindedThis = bind(this.onFullscreenChanged, this);
        this.isSupported = !!config.requestFullscreen;
        this.openCallback = openCallback;
        this.cancelCallback = cancelCallback;
        if (this.isSupported) {
            document.addEventListener(config.fullscreenEvent, this.onFullscreenChangedBindedThis);
        }
    }

    onFullscreenChanged(ele) {
        if (this.isSupported) {
            if (!document[config.fullscreenElement]) {
                this.closeFullscreen();
            }
            else {
                this.openFullscreen(ele);
            }
        }
    }

    /**
     * 打开全屏
     */
    openFullscreen(ele) {
        if (this.isSupported) {
            if (!document[config.fullscreenElement]) {
                config.requestFullscreen.call(ele);
            }
            this.openCallback && this.openCallback();
        }
    }

    /**
     * 关闭全屏
     */
    closeFullscreen() {
        if (this.isSupported) {
            if (document[config.fullscreenElement]) {
                config.cancelFullscreen.call(document);
            }
            this.cancelCallback && this.cancelCallback();
        }
    }

    toggleFullscreen(ele) {
        if (this.isSupported) {
            if (document[config.fullscreenElement]) {
                this.closeFullscreen();
            }
            else {
                this.openFullscreen(ele);
            }
        }
    }

    dispose() {
        if (config.requestFullscreen) {
            document.removeEventListener(config.fullscreenEvent, this.onFullscreenChangeBindedThis);
        }
    }
}